export class Direction {
    libelle: string;
    sigle: string;
}
